// extracted by mini-css-extract-plugin
export default {"modal":"GP-z","addItemButton":"HP-z","plusCircle":"IP-z","branchVisible":"JP-z"};